<template>
  <ion-content>
    <div class="login-fondo">
      <div class="login-tarjeta">
        <div class="login-marca">
          <div class="login-logo">R</div>
          <h1 class="login-titulo">Reclasin</h1>
          <p class="login-sub">Gestión de reclamación de siniestros</p>
        </div>

        <div class="login-campo">
          <label>Usuario o correo electrónico</label>
          <ion-input type="text" v-model="email" placeholder="tu@email.com" @keyup.enter="login()" />
        </div>

        <div class="login-campo">
          <label>Contraseña</label>
          <ion-input type="password" v-model="password" placeholder="••••••••" @keyup.enter="login()" />
        </div>

        <ion-button expand="block" color="dark" class="login-btn" @click="login()">
          Entrar
        </ion-button>
      </div>
    </div>
  </ion-content>
</template>

<script>
import { IonButton, IonInput } from "@ionic/vue";
import axios from 'axios'
import jwtToken from "@/plugins/jwt/jwt-token";
import {mapActions} from "vuex";
import user from "@/plugins/jwt/user";
import  '@capacitor-community/facebook-login';
import  '@codetrix-studio/capacitor-google-auth';
import { Plugins } from '@capacitor/core'
import toast from '@/plugins/toast'
//import Form from "../components/Form";
//import People from "../components/People";
//import PayCardOverview from "../components/PayCardOverview";

export default {
  name: "pay",
  title: "Pay",
  requiresAuth: false,
  components: {
    //IonPage,
    IonInput,
    //Form,
    //People,
    //PayCardOverview,
    IonButton
  },
  data() {
    return {
      email : '',
      password : ''
    };
  },
  mounted(){
    Plugins.GoogleAuth.initialize()
   
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: '403919611251185',
        cookie: true, // enable cookies to allow the server to access the session
        xfbml: true, // parse social plugins on this page
        version: 'v12.0' // use graph api current version
      });
    };

    // Load the SDK asynchronously
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },
  methods: {
    ...mapActions([
          'setAuthUser',
    ]),
    async login(){

      var loading = await toast.showLoading()

      loading.present();

      let data = {
        email : this.email,
        password : this.password
      }

      axios.post('/api/auth/login',data)
      .then(res =>{
        loading.dismiss()
        console.log(res)
        user.setUser(res.data.user)
        jwtToken.setToken(res.data.token);
        this.setAuthUser(res.data.user)
        console.log(res.data.user.role.name)
        
        if (res.data.user.role.name == 'Despacho') {
          location.href = '/escritorio'
        }else{
           location.href = res.data.user.permissions[0].key
        }
        
       
      }).catch(error => {
        loading.dismiss()
        if (error.response.status == 400) {
          toast.openToast("Creendenciales Invalidas","error",10000);
        }
        
        console.log(error)
      })
    },
    redirect(){
      location.href = "/register"
    },
    async loginFacebook(){


      const FACEBOOK_PERMISSIONS = ['email'];
      const result = await Plugins.FacebookLogin.login({ permissions: FACEBOOK_PERMISSIONS });

      if (result.accessToken) {
        this.token = result.accessToken;
      }else{
        toast.openToast("Error al registrar con facebook","error",2000);
        return
      }
      
      //alert(JSON.stringify(result))
      var loading = await toast.showLoading()

      await loading.present();

      const url = `https://graph.facebook.com/${this.token.userId}?fields=id,name,picture.width(720),email&access_token=${this.token.token}`;
    
      axios
      .get(url)
      .then(res => {
        this.fb_user = res.data
        
        axios
        .post("/auth/mobile/external",{email : this.fb_user.email , names :this.fb_user.name, provider : 'facebook',key : 'google'  })
        .then(async res => {
          loading.dismiss()
          user.setUser(res.data.user)
          jwtToken.setToken(res.data.token);
          this.setAuthUser(res.data.user)
          await Plugins.FacebookLogin.logout()
          this.$router.push({path: '/dashboard' , query : {set_fcm : true }});
        })
        .catch(err => {
          loading.dismiss()
          console.log(err.response)
          /*if(err.response.data?.message){
            toast.openToast(err.response.data.message,"error",2000);
          }else{
            toast.openToast("Ha ocurrido un error","error",2000);
          }*/
       }) 
      
      })
      .catch(err => {
        console.log(err)
        loading.dismiss()
        //toast.openToast("Ha ocurrido un error","error",2000);
      }) 
   },
    async loginGoogle() {
    
    const googleUser = await Plugins.GoogleAuth.signIn()
    
    console.log('my user: ', googleUser);
    
    if(!googleUser?.email){
      toast.openToast("Error al autenticar con google","error",2000);
      return
    }
    
    var loading = await toast.showLoading()

    await loading.present();

    let data = {
       email : googleUser.email,
       names : googleUser.name,
       provider : 'google',
       key : 'google' 
    }

    axios
      .post("/auth/mobile/external",data)
      .then(async res =>  {
        loading.dismiss()
        user.setUser(res.data.user)
        jwtToken.setToken(res.data.token);
        this.setAuthUser(res.data.user)
        await Plugins.GoogleAuth.signOut();
        this.$router.push({path: '/dashboard' , query : {set_fcm : true }});
      })
      .catch(err => {
        loading.dismiss()
        console.log(err.response)
        /*if(err.response.data?.message){
          toast.openToast(err.response.data.message,"error",2000);
        }else{
          toast.openToast("Ha ocurrido un error","error",2000);
        }*/
      });
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: radial-gradient(1200px 600px at 50% -10%, #1e293b 0%, #0f172a 60%, #0b1220 100%);
}

.login-fondo {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.login-tarjeta {
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  padding: 34px 30px 28px;
}

.login-marca {
  text-align: center;
  margin-bottom: 24px;
}

.login-logo {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  border-radius: 16px;
  background: linear-gradient(135deg, #4f46e5, #6366f1);
  color: #fff;
  font-size: 28px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(79, 70, 229, 0.4);
}

.login-titulo {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
}

.login-sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: #94a3b8 !important;
}

.login-campo {
  margin-bottom: 14px;
}

.login-campo label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #334155 !important;
  margin-bottom: 6px;
}

.login-campo ion-input {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  --padding-start: 14px;
  --padding-end: 14px;
  --color: #0f172a;
  font-size: 15px;
}

.login-btn {
  margin-top: 8px;
  --border-radius: 10px;
  height: 48px;
  font-weight: 700;
  text-transform: none;
}

.login-btn-registro {
  --color: #4f46e5;
  text-transform: none;
  font-weight: 600;
  margin-top: 2px;
}

.login-sep {
  display: flex;
  align-items: center;
  text-align: center;
  color: #94a3b8;
  font-size: 12px;
  margin: 18px 0 14px;
}

.login-sep::before,
.login-sep::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e2e8f0;
}

.login-sep span {
  padding: 0 12px;
}

.login-social {
  display: flex;
  justify-content: center;
  gap: 18px;
}

.login-social img {
  width: 42px;
  height: 42px;
  cursor: pointer;
  border-radius: 50%;
  transition: transform 0.15s ease;
}

.login-social img:hover {
  transform: scale(1.08);
}
</style>



